import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {ActivatedRoute, Router} from '@angular/router';
import { URLSearchParams } from '@angular/http';

@Component({
  selector: "app-mobile-app",
  templateUrl: "./mobile-app.component.html",
  styleUrls: ["./mobile-app.component.scss"]
})
export class MobileAppComponent implements OnInit {
  public fiestaClubForm: FormGroup;
  public formSentSuccess = false;
  public formSubmitting = false;
  public showErrorMessage = false;


  constructor(private _fb: FormBuilder, private _router: Router) {}

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/mobile-app/mobile-app.component.ts